import { PanelBody, PanelRow, TabPanel, Panel, TextControl, Button, TextareaControl, Dashicon, ClipboardButton } from "@wordpress/components";

import { InspectorControls } from "@wordpress/block-editor";
import { useState } from "@wordpress/element";
import { __ } from "@wordpress/i18n";

/* eslint-disable react/prop-types */

// import BRangeControl from "./../../Components/BRangeControl";

import { BUnitControl } from "./../../../..//wp-utils/v1/components";
import { useWPAjaxMutation } from "../../../../wp-utils/v1/hooks";

const Settings = ({ setAttributes, attributes }) => {
  const { source, presets = [] } = attributes;

  const [copied, setCopied] = useState(false);

  const { saveData: deletePreset, isLoading: isDeleting } = useWPAjaxMutation(ytpPlayer?.ajaxURL, {
    nonce: ytpPlayer?.nonce,
    method: "deletePreset",
    action: "ytp_ajax",
    model: "Presets",
  });

  const postId = wp.data.select("core/editor").getCurrentPostId();
  const postType = wp.data.select("core/editor").getCurrentPostType();

  const { additionalCSS, additionalID } = attributes;

  // const [newChapterDraft, setNewChapterDraft] = useState({});

  // const handleChapter = (chapter, index) => {
  //   const newChapters = [...chapters];
  //   newChapters[index] = chapter;
  //   setAttributes({ chapters: newChapters });
  // };

  // const handleAdd = () => {
  //   const newChapters = [...chapters];
  //   newChapters.push(newChapterDraft);
  //   setAttributes({ chapters: newChapters });
  //   setNewChapterDraft({});
  // };

  // const handleRemove = (itemIndex) => {
  //   const newChapters = [...chapters];
  //   setAttributes({
  //     chapters: newChapters.filter((item, index) => index !== itemIndex),
  //   });
  // };

  /**
   * Delete preset
   * @param {*} id
   */
  const handleDeletePreset = async (id) => {
    if (confirm("Are you sure you want to delete this preset")) {
      try {
        await deletePreset({ id });
        setAttributes({ presets: presets.filter((item) => item.id !== id) });
      } catch (error) {
        // Prints: error message
        // eslint-disable-next-line no-console
        console.log(error.message);
      }
    }
  };

  const setStyle = (key, value) => {
    setAttributes({ [key]: { ...attributes[key], ...value } });
  };
  const getStyle = (selector, property) => {
    return attributes[selector]?.[property];
  };

  return (
    <>
      <InspectorControls style={{ marginBottom: "40px" }}>
        {postType === "ytplayer" && (
          <PanelBody>
            <PanelRow>
              <div className="ytp_front_shortcode">
                <ClipboardButton
                  title={copied ? __("Copied", "ytp") : ""}
                  variant="primary"
                  text={`[ytplayer id=${postId}]`}
                  onCopy={() => setCopied(true)}
                  onFinishCopy={() => setCopied(false)}
                >
                  {/* <input value={`[ytplayer id=${postId}]`} /> */}
                  <span className="htooltip">{__("Copy To Clipboard", "ytp")}</span>
                  {__("Copy Shortcode", "ytp")}
                </ClipboardButton>
              </div>
            </PanelRow>
          </PanelBody>
        )}

        <TabPanel
          className="bPSS"
          activeClassName="active-tab"
          tabs={[
            {
              name: "settings",
              title: "Settings",
              className: "general btTab",
            },
            {
              name: "style",
              title: "Style",
              className: "style btTab",
            },
          ]}
        >
          {(tab) => {
            return (
              <span>
                {tab.name == "settings" && (
                  <span>
                    <Panel>
                      <PanelBody>
                        <PanelRow>
                          <TextControl label={__("Video source", "ytp")} value={source} onChange={(source) => setAttributes({ source })} placeholder="Youtube video link" />
                        </PanelRow>
                        {/* <PanelRow> */}
                        {/* <label>{__('Video Thumbnail', 'ytp')}</label> */}
                        {/* <BMediaUpload value={thumbnail} onSelect={(thumbnail) => setAttributes({ thumbnail })} label={__("Video Thumnail", "ytp")} placeholder={__("Video Thumbnail", "ytp")} /> */}
                        {/* </PanelRow> */}
                      </PanelBody>
                      <PanelBody title={__("Presets", "ytp")}>
                        <div className={`ytp-presets ${isDeleting ? "presetDeleting" : ""}`}>
                          {presets?.length &&
                            presets?.map((item) => (
                              <>
                                <div className={`ytp-preset-item`}>
                                  <div
                                    className="box"
                                    onClick={() => {
                                      setAttributes({ presetID: item?.id + "" });
                                    }}
                                  >
                                    <span>{item.name?.[0]?.toUpperCase()}</span>
                                  </div>
                                  <div className="actions">
                                    <Dashicon
                                      icon="edit"
                                      title={__("Edit", "ytp")}
                                      onClick={() => {
                                        setAttributes({ editingPresetID: item.id, presetOpened: true });
                                      }}
                                    />
                                    {presets?.length > 1 && <Dashicon icon="trash" title={__("Delete", "ytp")} onClick={() => handleDeletePreset(item.id)} />}
                                  </div>
                                  <p>{item?.name || __("Unknown Name", "ytp")}</p>
                                </div>
                              </>
                            ))}
                        </div>
                        <Button onClick={() => setAttributes({ editingPresetID: null, presetOpened: true })} variant="primary">
                          {__("Create New Preset", "ytp")}
                        </Button>
                      </PanelBody>
                      <PanelBody title={__("Additional", "ytp")} initialOpen={false}>
                        <TextControl label={__("Additional ID", "ytp")} value={additionalID} onChange={(additionalID) => setAttributes({ additionalID })} />
                        <TextareaControl label={__("Additional CSS", "ytp")} value={additionalCSS} onChange={(additionalCSS) => setAttributes({ additionalCSS })} />
                      </PanelBody>
                    </Panel>
                  </span>
                )}
                {/* {tab.name == "controls" && <BControls attributes={attributes} setAttributes={setAttributes} />} */}
                {tab.name == "style" && (
                  <span>
                    <Panel>
                      <PanelBody>
                        <BUnitControl
                          onChange={(width) => setStyle("ytWrapperStyle", { width })}
                          value={getStyle("ytWrapperStyle", "width")}
                          label={__("Width", "ytp")}
                          labelPosition="side"
                          em="30"
                        />
                      </PanelBody>
                    </Panel>
                  </span>
                )}
              </span>
            );
          }}
        </TabPanel>
      </InspectorControls>
    </>
  );
};

export default Settings;
